module.exports = __webpack_public_path__ + "img/OBCINA POSTOJNA.a51208c8.png";